import { formatForId, getElementPosition, stripTags } from './utils';

// Summary
const summaryClass = 'c-summary';
const summaryItemClass = summaryClass + '__item';
const summaryLinkClass = summaryClass + '__link';
const summaryLinkActiveClass = summaryLinkClass + '--active';

const summaryJsClass = 'js-summary';
const summaryAnchorJsClass = summaryJsClass + '-anchor';
const summaryTitleJsClass = summaryJsClass + '-title';
const summaryNavJsClass = summaryJsClass + '-nav';
const summaryListJsClass = summaryJsClass + '-list';

const summaryElement = document.querySelector('.' + summaryJsClass) as HTMLElement;
const summaryNavElement = document.querySelector('.' + summaryNavJsClass) as HTMLElement;
const summaryListElement = document.querySelector('.' + summaryListJsClass) as HTMLElement;
const summaryTitleElement = document.querySelector('.' + summaryTitleJsClass) as HTMLElement;
const summaryAnchorElements = document.querySelectorAll('.' + summaryAnchorJsClass) as NodeListOf<HTMLElement>;

const summaryLinkElements = [];
let activeLinkIndex: number = null; // To keep track of the active link index in the array

if (summaryElement && summaryTitleElement && summaryNavElement && summaryListElement) {
    if (summaryAnchorElements.length > 0) {
        // We create a link in the summary for each anchor found
        summaryAnchorElements.forEach((summaryAnchorElement) => {
            createSummaryAnchorLink(summaryAnchorElement);
        });

        // We update the active link
        updateActiveSummaryLink();
    } else {
        // We hide the title and the list since there are no anchors in the page
        summaryTitleElement.style.display = 'none';
        summaryNavElement.style.display = 'none';
    }
}

function createSummaryAnchorLink (summaryAnchorElement: HTMLElement): void {
    // We get the position of the element in the page
    const position = getElementPosition(summaryAnchorElement);

    // We create a unique id for the anchor using it's content and it's position to avoid duplicates
    const anchorId = `${formatForId(summaryAnchorElement.innerText)}-${position.x}-${position.y}`;

    // We assign the id to the anchor
    summaryAnchorElement.id = anchorId;

    // We create a list item
    const itemElement = document.createElement('li');
    itemElement.classList.add(summaryItemClass);

    // We create a link
    const linkElement = document.createElement('a');
    linkElement.classList.add(summaryLinkClass);

    // We set the link's href to the corresponding anchor
    const hash = '#' + anchorId;
    linkElement.href = window.location.origin + window.location.pathname + hash;

    // We get the anchor's text and remove any unwanted tags
    const anchorText = stripTags(summaryAnchorElement.innerHTML);

    // We set the link's text to the anchor's text
    linkElement.innerHTML = anchorText;

    // We add the link to our array
    summaryLinkElements.push(linkElement);

    // We put the link inside the item
    itemElement.appendChild(linkElement);

    // We put the item inside the list
    summaryListElement.appendChild(itemElement);
}

export function updateActiveSummaryLink (): void {
    let newActiveLinkIndex: number = null;

    summaryAnchorElements.forEach((summaryAnchorElement: HTMLElement, index: number) => {
        // We get the position of the element in the page
        const position = getElementPosition(summaryAnchorElement);

        // We create a small padding to activate links a little earlier
        const scrollPadding =  10;

        // If we have scrolled up to, or past the anchor, we set the corresponding link index as active
        if (window.scrollY + scrollPadding >= position.y) {
            newActiveLinkIndex = index;
        }
    });

    // If the active index has changed
    if (newActiveLinkIndex !== activeLinkIndex) {
        // We deactivate the currently active link
        if (activeLinkIndex !== null) {
            summaryLinkElements[activeLinkIndex].classList.remove(summaryLinkActiveClass);
            summaryLinkElements[activeLinkIndex].removeAttribute('title');
        }

        // We update the active link
        activeLinkIndex = newActiveLinkIndex;
    } else {
        // Otherwise we stop here
        return;
    }

    // If we have a new link to activate we do it here
    if (activeLinkIndex !== null) {
        summaryLinkElements[activeLinkIndex].classList.add(summaryLinkActiveClass);
        summaryLinkElements[activeLinkIndex].title = `${summaryLinkElements[activeLinkIndex].innerText} - Rubrique active`;
    }
}